import React from "react";
import PropTypes from "prop-types";
import { ToCurrency } from "../../../utils/currency";

const LoyaltyToolTip = props => {
  const { loyaltyPoints } = props;
  return (
    <div className="nw-loyaltytooltip-parent">
      <i className="icomoon-info nw-loyaltytooltip-icon" />
      <div className="nw-loyaltytooltip-info">
        {loyaltyPoints &&
          loyaltyPoints.map(point => (
            <div>
              {point.brand} : {ToCurrency(point.loyaltyValue)}
            </div>
          ))}
      </div>
    </div>
  );
};

LoyaltyToolTip.propTypes = {
  loyaltyPoints: PropTypes.arrayOf(
    PropTypes.shape({
      brand: PropTypes.string.isRequired,
      loyaltyValue: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: LoyaltyToolTip,
  component: LoyaltyToolTip,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Loyalty/LoyaltyToolTip/index.js